import { FUNCTIONS_BASE } from './siteConfig.js';

const NEWS_URL = `${FUNCTIONS_BASE}/searchLocalNews`;
const CACHE_KEY = 'nmr_local_news_cache_v1';
const CACHE_MS = 15 * 60 * 1000;

function readCache() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.fetchedAt || !Array.isArray(parsed.news)) return null;
    if (Date.now() - parsed.fetchedAt > CACHE_MS) return null;
    return parsed.news;
  } catch {
    return null;
  }
}

function writeCache(news) {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ fetchedAt: Date.now(), news }));
  } catch {
    // ignore quota errors
  }
}

async function requestLocalNews(authToken) {
  const headers = { 'Content-Type': 'application/json' };
  if (authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }
  const response = await fetch(NEWS_URL, {
    method: 'POST',
    headers,
    body: JSON.stringify({}),
  });
  if (!response.ok) {
    throw new Error(`Local news fetch failed with status ${response.status}`);
  }
  const data = await response.json();
  return Array.isArray(data?.news) ? data.news : [];
}

/**
 * Fetch WNC local news. Tries authenticated request first, then anonymous (rate-limited).
 * Uses a short session cache so dashboard reloads stay populated.
 */
export async function fetchLocalNews({ user } = {}) {
  const cached = readCache();
  if (cached?.length) {
    return { news: cached, fromCache: true };
  }

  let token = null;
  if (user?.getIdToken) {
    try {
      token = await user.getIdToken();
    } catch {
      token = null;
    }
  }

  let news = [];
  try {
    news = await requestLocalNews(token);
  } catch (authError) {
    console.warn('Authenticated local news fetch failed, retrying without token:', authError);
    news = await requestLocalNews(null);
  }

  if (news.length > 0) {
    writeCache(news);
  }

  return { news, fromCache: false };
}